/**
 * A key decision as defined in key-decisions.json.
 * Constructor parameters are injected in KeyDecisionConfig.js.
 */
export default class KeyDecisionDefinition {
    constructor(id, chapter, arc, contentId, backgroundImageId, unlockedByContentId) {
        this._id = id;
        this._chapter = chapter;
        this._arc = arc;
        this._contentId = contentId;
        this._backgroundImageId = backgroundImageId;
        this._unlockedByContentId = unlockedByContentId;
    }

    get id() {
        return this._id;
    }

    get chapter() {
        return this._chapter;
    }

    get arc() {
        return this._arc;
    }

    get contentId() {
        return this._contentId;
    }

    get unlockedByContentId() {
        return this._unlockedByContentId;
    }

    get backgroundImageId() {
        return this._backgroundImageId;
    }
}